import { useI18nState } from '../../../stores/settings/language-context';
import './bi-view.scss';

export default function BiView() {
  const { localeData } = useI18nState();

  return (
    <div className="bi-view-empty" data-testid="bi_view">
      <p className="bi-view-empty-text">{localeData.BiViewComingSoon}</p>
    </div>
  );
}
